export const dataHooks = {
  RadioGroupFixerSelectedOptionOptionElement: dataHook => `radio-group-fixer-selected-option-option-element-${dataHook}`,
  a11yWizardHoverBoxContainer: dataHook => `rules-ui-hover-box-container-${dataHook}`,
  a11yWizardHoverBoxContainerDiv: dataHook => `rules-ui-hover-box-container-div-${dataHook}`,
  a11yWizardHoverBoxIconButton: dataHook => `rules-ui-hover-box-icon-button-${dataHook}`,
  a11yWizardHoverBoxIconButtonTooltip: dataHook => `rules-ui-hover-box-icon-button-tooltip-${dataHook}`,
  aiNotificationApplyButton: dataHook => `${dataHook}-apply-button`,
  aiNotificationDisclaimer: dataHook => `${dataHook}-disclaimer`,
  aiNotificationFixedTitle: dataHook => `${dataHook}-fixed-title`,
  aiNotificationManualTitle: dataHook => `${dataHook}-manual-title`,
  aiNotificationShowMoreButton: dataHook => `${dataHook}-show-more-button`,
  aiNotificationUndoButton: dataHook => `${dataHook}-undo-button`,
  aiSectionHelperLabel: dataHook => `${dataHook}-label`,
  aiSectionHelperSuggestion: dataHook => `${dataHook}-suggestion`,
  // Alt-text fixer data hooks
  altTextFixerEditButton: 'alt-text-fixer-edit-button',
  altTextFixerFilledText: 'alt-text-fixer-filled-text',
  altTextFixerMoreImages: 'alt-text-fixer-more-images',
  altTextFixerPreviewImage: 'alt-text-fixer-preview-image',
  altTextFixerRuleFooter: 'alt-text-fixer-rule-footer',
  altTextFixerTaskItem: 'alt-text-fixer-task-item',
  altTextFixerWrapper: 'alt-text-fixer-wrapper',
  autoCompleteFieldDropdownFixer: dataHook => `dropdown-fixer-autoComplete-field-${dataHook}`,
  completedTaskContainer: dataHook => `rules-ui-completed-task-container-${dataHook}`,
  completedTaskDropdownFixer: dataHook => `dropdown-fixer-completed-task-${dataHook}`,
  completedTaskEditButton: dataHook => `rules-ui-completed-task-edit-button-${dataHook}`,
  completedTaskInputFixer: dataHook => `input-fixer-completed-task-${dataHook}`,
  completedTaskRadioGroupFixer: dataHook => `radio-group-fixer-completed-task-${dataHook}`,
  completedTaskToggleFixer: dataHook => `toggle-fixer-completed-task-${dataHook}`,
  evergreenRule: dataHook => `evergreen-${dataHook}`,
  evergreenRuleCompletedTask: dataHook => `evergreen-completed-task-${dataHook}`,
  fixWithAiButtonCancel: dataHook => `${dataHook}-cancel`,
  footerInputFixer: dataHook => `input-fixer-footer-${dataHook}`,
  footerRadioGroupFixer: dataHook => `radio-group-fixer-footer-${dataHook}`,
  footerToggleFixer: dataHook => `toggle-fixer-footer-${dataHook}`,
  formFieldDropdownFixer: dataHook => `dropdown-fixer-form-field-${dataHook}`,
  formFieldInputFixer: dataHook => `input-fixer-form-field-${dataHook}`,
  groupsList: dataHook => `rules-ui-rule-groups-accordion-${dataHook}`,
  groupsListContent: groupId => `group-content-${groupId}`,
  inputFieldInputFixer: dataHook => `input-fixer-input-field-${dataHook}`,
  issueCounterBadge: dataHook => `issue-counter-badge-${dataHook}`,
  overviewSectionCardContainer: dataHook => `rules-ui-overview-section-card-container-${dataHook}`,
  overviewSectionIssueNumberText: dataHook => `rules-ui-overview-section-issue-number-text-${dataHook}`,
  radioGroupFieldRadioGroupFixer: dataHook => `radio-group-fixer-radio-group-field-${dataHook}`,
  ruleContent: ruleId => `rule-content-${ruleId}`,
  ruleElementBorderBox: dataHook => `rule-element-border-box-${dataHook}`,
  ruleElementCollapse: dataHook => `rule-element-collapse-${dataHook}`,
  ruleElementGeneratedStatusIcon: dataHook => `rule-element-green-status-icon-${dataHook}`,
  ruleElementGreenStatusIcon: dataHook => `rule-element-green-status-icon-${dataHook}`,
  ruleElementHoverBox: dataHook => `rule-element-hover-box-${dataHook}`,
  ruleElementListHeader: dataHook => `a11y-wizard-rule-element-list-header-${dataHook}`,
  ruleElementRedStatusIcon: dataHook => `rule-element-red-status-icon-${dataHook}`,
  ruleElementYellowStatusIcon: dataHook => `rule-element-yellow-status-icon-${dataHook}`,
  ruleFooterDismissButton: dataHook => `rules-ui-rule-footer-dismiss-button-${dataHook}`,
  ruleFooterIconButton: dataHook => `rules-ui-rule-footer-icon-button-${dataHook}`,
  ruleFooterLoader: dataHook => `rules-ui-rule-footer-loader-${dataHook}`,
  ruleFooterSubmitButton: dataHook => `rules-ui-rule-footer-submit-button-${dataHook}`,
  rulesList: 'rules-list',
  rulesListPrefixIconComplete: 'rules-ui-rules-list-prefix-icon-complete',
  rulesListPrefixIconDisabled: 'rules-ui-rules-list-prefix-icon-disabled',
  rulesListPrefixIconError: 'rules-ui-rules-list-prefix-icon-error',
  rulesListPrefixIconFailed: 'rules-ui-rules-list-prefix-icon-failed',
  rulesListPrefixIconLoading: 'rules-ui-rules-list-prefix-icon-loading',
  rulesListPrefixIconPending: 'rules-ui-rules-list-prefix-icon-pending',
  rulesListPrefixIconRecommendation: 'rules-ui-rules-list-prefix-icon-recommendation',
  rulesPanelUiWrapper: 'rules-panel-ui-wrapper',
  stickyHeaderRoundedCorners: 'sticky-header-rounded-corners',
  toggleFieldToggleFixer: dataHook => `toggle-fixer-toggle-field-${dataHook}`
};
//# sourceMappingURL=datahooks.js.map